import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-buttons/styles/material.css";
import "@syncfusion/ej2-react-popups/styles/material.css";
import "react-table-6/react-table.css";
import Combobox from 'react-widgets/lib/Combobox';
import Loader from 'react-loader-spinner';


class AvatarSetting extends Component {
    constructor() {
        super();
        this.state = {
            enterprise: false,
            fields: {
                customerId: "",
                enabled: false,
                sceneId: "",
                sceneVersionId: "",
                useSitepalSpeech: true
            },
            showEditBtn: false,
            editable: true,
            hideDeletePopup: false,
            loadView: false
        }
        this.settings = { effect: 'Zoom', duration: 400, delay: 0, position: 'center' };
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': (props) => {
                this.deleteOrgDetails()
            }
        },
        {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({ hideDeletePopup: false });
            }
        }];
        this.dialogClose = () => {
            this.setState({
                hideDeletePopup: false,
            });
        };

    }

    componentDidMount() {
        let thisController = this;
        setTimeout(() => {
            thisController.fetchProjectAvatarSettingApi();
        }, 500);

        document.addEventListener("projectChanged", function (event) {
            thisController.projectId = event.projectId;
            thisController.fetchProjectAvatarSettingApi(event.projectId);
        });
    }

    handleChangeForInPut = (e) => {
        let fields = this.state.fields;
        fields[e.target.name] = e.target.value;
        this.setState({
            fields
        });
    }

    refreshData = () => {
        this.state.errors = {};
        this.setState(this.state);
        this.fetchProjectAvatarSettingApi();
    }

    fetchProjectAvatarSettingApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        let data = { projectId: projectId }
        let avatarSettingsComponent = this;
        avatarSettingsComponent.state.loadView = false;
        $.ajax({
            url: "/api/project-avatar-setting",
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },
            data: data,
            success: function (res) {
                avatarSettingsComponent.state.loadView = true;
                if (res.success === true) {
                    avatarSettingsComponent.state.fields = res.result.sitepalAvatarSettings[0];
                    if (avatarSettingsComponent.state.fields.enabled == "true" ||
                        avatarSettingsComponent.state.fields.enabled == true) {
                        avatarSettingsComponent.state.fields.enabled = true;
                    } else {
                        avatarSettingsComponent.state.fields.enabled = false;
                    }
                    avatarSettingsComponent.state.editable = false;
                    avatarSettingsComponent.state.showEditBtn = true;
                    avatarSettingsComponent.setState(avatarSettingsComponent.state);
                } else {
                    avatarSettingsComponent.state.fields = { useSitepalSpeech: true };
                    if (document.getElementById("customerId") != null && document.getElementById("customerId") != undefined) {
                        document.getElementById("customerId").value = "";
                        document.getElementById("sceneId").value = "";
                        document.getElementById("sceneVersionId").value = "";
                        document.getElementById("enabled").defaultChecked = false;
                    }
                    avatarSettingsComponent.state.editable = true;
                    avatarSettingsComponent.state.showEditBtn = false;
                    avatarSettingsComponent.setState(avatarSettingsComponent.state);
                }
            },
            error: function (xhr, status, error) {
                var errorMessage = xhr.status + ': ' + status + " : " + error
                console.error(errorMessage);
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    notifyFailToLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }


    saveAvatarSettingsDetailsApi = () => {
        let thisController = this;
        if (thisController.validateAvatarSettingInputs()) {
            let data = thisController.state.fields;

            data["projectId"] = localStorage.getItem("currentProjectId");

            $.ajax({
                url: "/api/project-avatar-setting",
                type: 'PATCH',
                async: false,
                headers: {
                    "Authorization": "Bearer" + localStorage.getItem("access_token"),
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(data),
                success: function (res) {
                    if (res.success === true) {
                        thisController.notifySuccessToast("Project Avatar Settings Updated Successfully");
                        thisController.fetchProjectAvatarSettingApi();
                        thisController.setState(thisController.state);
                    } else {
                        thisController.notifyFailToLoad(res.result);
                    }
                },
                error: function (xhr, status, error) {
                    var errorMessage = xhr.status + ': ' + status + " : " + error
                    console.error(errorMessage);
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            });
        }
    }

    notifyInvalidFields = (message) => {
        toast.dismiss();
        toast(<b> <img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" /> &nbsp;&nbsp; {message}</b >, {
            position: "top-center"
        });
    }

    validateAvatarSettingInputs = () => {
        let fields = this.state.fields;
        let formIsValid = true;
        var pattern = new RegExp(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/);
        const numberRegex = /^[0-9\b]+$/;

        if (!fields["customerId"] || fields["customerId"].trim() == "") {
            this.notifyInvalidFields("Please fill all the fields")
            return false;
        } else if (!fields["sceneId"] || fields["sceneId"].trim() == "") {
            this.notifyInvalidFields("Please fill all the fields")
            return false;
        } else if (!fields["sceneVersionId"] || fields["sceneVersionId"].trim() == "") {
            this.notifyInvalidFields("Please fill all the fields")
            return false;
        }

        return true;

    }


    notifySuccessToast(response) {
        toast.dismiss();
        toast(<b>
            <img src="./assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;{response}</b>, {
            position: "top-center"
        });
    }

    handleTTSCheck = (e) => {
        var thisController = this;
        if (e.target.checked === true) {
            thisController.state.fields.useSitepalSpeech = true;
        } else {
            thisController.state.fields.useSitepalSpeech = false;
        }
        thisController.setState(thisController.state);

    }

    handleEnabledInputChange = (e) => {
        var avatarSettingsComponent = this;
        if (e.target.checked === true) {
            avatarSettingsComponent.state.fields.enabled = true;
        } else {
            avatarSettingsComponent.state.fields.enabled = false;
        }
        avatarSettingsComponent.setState(avatarSettingsComponent.state);
    }

    editAvatarSettingsDetails = () => {
        this.state.editable = true;
        this.state.showEditBtn = false;
        this.setState(this.state);
    }

    render() {
        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={!this.state.loadView}
                    height={300}
                    width={50}
                    timeout={3000}
                    style={{ textAlign: 'center' }} />
                {/* for toaster */}
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />

                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                {/* Select2 */}
                <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                {/* for Combobox styling */}
                <link rel="stylesheet" href="./assets/css/combobox-style.css" />

                < ToastContainer className="Toast-at-center" />
                <div className="wrapper" style={{ display: this.state.loadView ? 'block' : 'none', marginTop: '-20px' }}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-7">
                                <h6 className="nav-item" style={{ color: '#282a65', marginTop: '30px' }}>Avatar Integration</h6>
                            </div>
                            <div className="d-flex flex-row-reverse pt-2 col-sm-5">
                                <button className="btn action-button" style={{ marginTop: "6px" }}
                                    title="Refresh" onClick={this.refreshData}>
                                    <img src="./assets/images/refresh_white_24dp.png" />
                                </button>
                                <button type="button" className="btn action-button" onClick={this.editAvatarSettingsDetails}
                                    style={{
                                        marginTop: '6px',
                                        display: this.state.showEditBtn ? 'block' : 'none'
                                    }}>
                                    <img className="img-responsive cursor-change" src="./assets/images/editWithWhiteFilled.png" />
                                </button>
                                <button type="button" className="btn action-button"
                                    style={{
                                        marginTop: '6px',
                                        display: this.state.showEditBtn ? 'none' : 'block'
                                    }} onClick={this.saveAvatarSettingsDetailsApi}>Save</button>

                            </div>
                        </div>
                        {/* /.card-header */}

                        <div className="card-body p-0 mb-25">
                            <div className="tab-content col-12 p-0">
                                <div className="card card-primary mt-3">
                                    <div style={{ marginLeft: "30px", marginTop: "10px" }} className="raiseTicketLable">
                                        <div className="col-sm-12" style={{ marginTop: "10px", marginBottom: '50px' }}>
                                            <div className="col-sm-7">
                                                <div className="row" style={{ marginTop: '20px' }}>
                                                    <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Enabled</div>
                                                    <label class="switch" style={{ marginLeft: '15px', marginTop: '7px' }}>
                                                        <input type="checkbox"
                                                            id="enabled"
                                                            name="enabled"
                                                            disabled={!this.state.editable}
                                                            onChange={this.handleEnabledInputChange}
                                                            checked={this.state.fields.enabled}
                                                        />
                                                        <span class="slider round" style={{ cursor: this.state.editButton ? 'default' : 'pointer' }}></span>
                                                    </label>
                                                </div>
                                                <div className="row" style={{ marginTop: '20px' }}>
                                                    <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Avatar Account ID</div>
                                                    <input className="col-sm-8"
                                                        type="text"
                                                        name="customerId" id="customerId" placeholder="Enter Avatar Account ID"
                                                        disabled={!this.state.editable}
                                                        value={this.state.fields.customerId}
                                                        onChange={this.handleChangeForInPut}
                                                        style={{
                                                            padding: '0.375rem 0.75rem', textAlign: 'left',
                                                            borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                        }} />
                                                </div>
                                                <div className="row" style={{ marginTop: '20px' }}>
                                                    <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Avatar Scene ID</div>
                                                    <input
                                                        type="text" className="col-sm-8"
                                                        name="sceneId" id="sceneId" placeholder="Enter Avatar Scene ID"
                                                        value={this.state.fields.sceneId}
                                                        disabled={!this.state.editable}
                                                        onChange={this.handleChangeForInPut}
                                                        style={{
                                                            padding: '0.375rem 0.75rem', textAlign: 'left',
                                                            borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                        }} />
                                                </div>
                                                <div className="row" style={{ marginTop: '20px' }}>
                                                    <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Scene Version ID</div>
                                                    <input className="col-sm-8"
                                                        type="text" id="sceneVersionId"
                                                        name="sceneVersionId" placeholder="Enter Scene Version ID"
                                                        value={this.state.fields.sceneVersionId}
                                                        disabled={!this.state.editable}
                                                        onChange={this.handleChangeForInPut}
                                                        style={{
                                                            padding: '0.375rem 0.75rem', textAlign: 'left',
                                                            borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                        }} />
                                                </div>
                                                <div className="row" style={{ marginTop: '20px' }}>
                                                    <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Use TTS included with Avatar (LipSynced)</div>
                                                    <label class="switch" style={{ marginLeft: '15px', marginTop: '7px' }}>
                                                        <input type="checkbox"
                                                            id="useSitepalSpeech"
                                                            name="useSitepalSpeech"
                                                            onChange={this.handleTTSCheck}
                                                            checked={this.state.fields.useSitepalSpeech}
                                                            disabled={!this.state.editable}
                                                            style={{ marginLeft: '6px' }}
                                                        />
                                                        <span class="slider round" style={{ cursor: this.state.editButton ? 'default' : 'pointer' }}></span>
                                                    </label>
                                                </div>
                                            </div>
                                            <span className="col-sm-12" style={{ marginTop: '20px' }}>
                                                * Want to include a talking avatar in your chat widget ? Get help from Dhee.AI team by writing to us at
                                                &nbsp;<a style={{ color: "rgb(0, 148, 200)", cursor: "pointer" }}>help@dhee.ai</a>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <DialogComponent width='400px' style={{ marginTop: "150px", position: "fixed" }} animationSettings={this.settings}
                                header='Project Avatar Settings' showCloseIcon={true} buttons={this.buttons}
                                ref={dialog => this.dialogInstance = dialog}
                                visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                    content="" />&nbsp;Do you want to delete?<br />Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent>
                        </div>
                    </div>
                </div >
            </div>
        );
    }
}
export default AvatarSetting;


// WEBPACK FOOTER //
// ./src/projectmgmt/settings/AvatarSetting.js